/**
 * @file error-helper.ts
 * @description Утилиты для обработки ошибок Axios и передачи их в список ошибок UI.
 * 
 * Содержит функции для извлечения массива ошибок из ответа AxiosError и для передачи этих ошибок в компонент списка ошибок.
 */

import { AxiosError } from 'axios';
import { TErrorMessage, TBaseObjectDto } from '@src/types';
import { ErrorListHandle } from '@components/ui/indicators/error-list';

//TODO: добавить тип для errorListRef
/**
 * Передаёт массив ошибок из AxiosError в компонент списка ошибок.
 *
 * @param {AxiosError} response - Объект ошибки Axios.
 * @param {ErrorListHandle | undefined} errorListHandle - Ссылка на компонент, принимающий массив ошибок.
 */
//TODO: ErrorListHandle пересмотреть за copilot
export const setErrors = (response: AxiosError, errorListHandle: ErrorListHandle | null): void => {
    const errors = extractAxiosErrors(response);

    if (errors.length && errorListHandle) {
        errorListHandle.setItems(
            errors.map(({ message, title, status }: TBaseObjectDto, key: number) => ({
                key,
                message,
                title,
                status
            }))
        );
    }
};

/**
 * Извлекает массив ошибок из объекта AxiosError.
 *
 * @param {AxiosError} error - Объект ошибки Axios.
 * @returns {TErrorMessage[]} Массив ошибок, если они есть в ответе; иначе пустой массив.
 */
export function extractAxiosErrors(error: AxiosError): TErrorMessage[] {
    const data = error.response?.data;

    if (
        typeof data === 'object' &&
        data !== null &&
        'errors' in data &&
        Array.isArray((data as TBaseObjectDto).errors)
    ) {
        return (data as TBaseObjectDto).errors;
    }

    return [];
}
